var _style, _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.5,93.1h395c-14.6-17.7-31.5-33.3-50.3-46.5H108.8C90,59.8,73.1,75.4,58.5,93.1L58.5,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,256c0,7.8,0.4,15.6,1.1,23.3h509.9c0.7-7.7,1.1-15.4,1.1-23.3s-0.4-15.6-1.1-23.3H1.1 C0.4,240.4,0,248.2,0,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,372.4h456.2c7.5-14.7,13.7-30.3,18.3-46.5H9.6C14.2,342,20.4,357.6,27.9,372.4L27.9,372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.8,465.5h294.4c18.8-13.2,35.7-28.9,50.3-46.5h-395C73.1,436.6,90,452.2,108.8,465.5L108.8,465.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.6,186.2h492.7c-4.6-16.2-10.7-31.8-18.3-46.5H27.9C20.4,154.4,14.2,170,9.6,186.2L9.6,186.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.4,46.5h280.8C361.6,17.2,310.8,0,256,0C222.6,0,164.1,17.2,122.4,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,139.6h239.2c-8.5-16.7-18.8-32.3-30.6-46.5H244.9L244.9,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,232.7h266.1c-1.4-16-4.3-31.5-8.6-46.5H244.9V232.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,325.8h492.7c4.2-15,7.1-30.6,8.6-46.5H1.1C2.5,295.3,5.4,310.8,9.6,325.8L9.6,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,418.9h395c11.8-14.3,22.1-29.9,30.6-46.5H27.9C36.4,389,46.7,404.6,58.5,418.9L58.5,418.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c54.8,0,105.6-17.2,147.2-46.5H108.8C150.4,494.8,201.2,512,256,512z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.6,186.2c-4.2,15-7.1,30.6-8.6,46.5H256V0C138.8,0,40,78.7,9.6,186.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.4,66.8l16.6,51h53.6l-43.4,31.5l16.6,51l-43.4-31.5L109,200.3l16.6-51l-43.4-31.5h53.6L152.4,66.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/lr.2be41876f0565c6ff33bbdaae7b19e38.svg";
export { ForwardRef as ReactComponent };